import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;
class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit = () => {
    const { data, isAddType } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {};
        if (isAddType) {
          params.parentUuid = null;
          data && data.uuid && (params.parentUuid = data.uuid);
        } else {
          params.uuid = data.uuid;
          params.parentUuid = data.parentUuid;
        }
        params.name = values.name;
        this.props.onOk(params);
        this.props.form.resetFields();
      }
    });
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, isAddType } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title={isAddType ? '创建目录' : '编辑目录'}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <FormItem label="目录名称" {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请填写目录名称' }],
              initialValue: isAddType ? null : data.name,
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetailManage/ModalDirAdd.js